// Recovered compiled webpack factory 45130. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { j: () => P });
  var n = i(23656),
    s = i(78041),
    r = i(21391),
    o = i(55389),
    a = i(24888),
    l = i(68894),
    h = i(44807);
  function u(t, e, i) {
    return (i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6)
      ? t + (e - t) * 6 * i
      : i < 0.5
        ? e
        : i < 2 / 3
          ? t + (e - t) * (2 / 3 - i) * 6
          : t;
  }
  var d = i(31739);
  function c(t, e) {
    return (i) => (i > 0 ? e : t);
  }
  var p = i(39361);
  let m = (t, e, i) => {
      let n = t * t,
        s = i * (e * e - n) + n;
      return s < 0 ? 0 : Math.sqrt(s);
    },
    f = [l.u, d.B, h.V];
  function v(t) {
    let e = f.find((e) => e.test(t));
    if (
      ((0, s.$)(
        !!e,
        `'${t}' is not an animatable color. Use the equivalent color code instead.`,
        "color-not-animatable",
      ),
      !e)
    )
      return !1;
    let i = e.parse(t);
    return (
      e === h.V &&
        (i = (function ({ hue: t, saturation: e, lightness: i, alpha: n }) {
          ((t /= 360), (i /= 100));
          let s = 0,
            r = 0,
            o = 0;
          if ((e /= 100)) {
            let n = i < 0.5 ? i * (1 + e) : i + e - i * e,
              a = 2 * i - n;
            ((s = u(a, n, t + 1 / 3)), (r = u(a, n, t)), (o = u(a, n, t - 1 / 3)));
          } else s = r = o = i;
          return {
            red: Math.round(255 * s),
            green: Math.round(255 * r),
            blue: Math.round(255 * o),
            alpha: n,
          };
        })(i)),
      i
    );
  }
  let y = (t, e) => {
      let i = v(t),
        n = v(e);
      if (!i || !n) return c(t, e);
      let s = { ...i };
      return (t) => (
        (s.red = m(i.red, n.red, t)),
        (s.green = m(i.green, n.green, t)),
        (s.blue = m(i.blue, n.blue, t)),
        (s.alpha = (0, p.k)(i.alpha, n.alpha, t)),
        d.B.transform(s)
      );
    },
    g = new Set(["none", "hidden"]);
  function x(t, e) {
    return (i) => (0, p.k)(t, e, i);
  }
  function w(t) {
    return "number" == typeof t
      ? x
      : "string" == typeof t
        ? (0, r.pG)(t)
          ? c
          : o.y.test(t)
            ? y
            : S
        : Array.isArray(t)
          ? T
          : "object" == typeof t
            ? o.y.test(t)
              ? y
              : b
            : c;
  }
  function T(t, e) {
    let i = [...t],
      n = i.length,
      s = t.map((t, i) => w(t)(t, e[i]));
    return (t) => {
      for (let e = 0; e < n; e++) i[e] = s[e](t);
      return i;
    };
  }
  function b(t, e) {
    let i = { ...t, ...e },
      n = {};
    for (let s in i) void 0 !== t[s] && void 0 !== e[s] && (n[s] = w(t[s])(t[s], e[s]));
    return (t) => {
      for (let e in n) i[e] = n[e](t);
      return i;
    };
  }
  let S = (t, e) => {
    let i = a.f.createTransformer(e),
      r = (0, a.V)(t),
      o = (0, a.V)(e);
    return r.indexes.var.length === o.indexes.var.length &&
      r.indexes.color.length === o.indexes.color.length &&
      r.indexes.number.length >= o.indexes.number.length
      ? (g.has(t) && !o.values.length) || (g.has(e) && !r.values.length)
        ? (function (t, e) {
            return g.has(t) ? (i) => (i <= 0 ? t : e) : (i) => (i >= 1 ? e : t);
          })(t, e)
        : (0, n.F)(
            T(
              (function (t, e) {
                let i = [],
                  n = { color: 0, var: 0, number: 0 };
                for (let s = 0; s < e.values.length; s++) {
                  let r = e.types[s],
                    o = t.indexes[r][n[r]],
                    a = t.values[o] ?? 0;
                  ((i[s] = a), n[r]++);
                }
                return i;
              })(r, o),
              o.values,
            ),
            i,
          )
      : ((0, s.$)(
          !0,
          `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`,
          "complex-values-different",
        ),
        c(t, e));
  };
  function P(t, e, i) {
    return "number" == typeof t && "number" == typeof e && "number" == typeof i
      ? (0, p.k)(t, e, i)
      : w(t)(t, e);
  }
}
